// extracted by mini-css-extract-plugin
export default {"skeleton":"newsImage_skeleton__bRtId"};